import { createSlice } from "@reduxjs/toolkit";
import { createAddressThunk } from "./thunks/create-address-thunk";
import { editAddressThunk } from "./thunks/edit-address-thunk";
import { getAddressListThunk } from "./thunks/get-address-list-thunk";
const slice = createSlice({
    name: "address",
    initialState: {
        addressList: [],
        loading: false,
    },
    reducers: {
        setAddressList: (state, { payload }) => {
            state.addressList = payload;
        },
        addAddress: (state, { payload }) => {
            state.addressList = [...state.addressList, payload];
        },
        editAddress: (state, { payload }) => {
            state.addressList = [...state.addressList.filter(({ _id }) => _id !== payload?._id), payload];
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getAddressListThunk.fulfilled, (state, action) => {
            state.loading = false;
        })
            .addCase(getAddressListThunk.rejected, (state, action) => {
            state.loading = false;
        })
            .addCase(getAddressListThunk.pending, (state, action) => {
            state.loading = true;
        })
            .addCase(createAddressThunk.fulfilled, (state, action) => {
            state.loading = false;
        })
            .addCase(createAddressThunk.rejected, (state, action) => {
            state.loading = false;
        })
            .addCase(createAddressThunk.pending, (state, action) => {
            state.loading = true;
        })
            .addCase(editAddressThunk.fulfilled, (state, action) => {
            state.loading = false;
        })
            .addCase(editAddressThunk.rejected, (state, action) => {
            state.loading = false;
        })
            .addCase(editAddressThunk.pending, (state, action) => {
            state.loading = true;
        });
    },
});
export const { addAddress, setAddressList, editAddress } = slice.actions;
export default slice.reducer;
